<template>
  <CustomForm ref="form" :inputs=inputs :submit=buttons.submit style="max-width: 400px; margin: auto;">
    <CustomTextField :content=inputs.name />
    <CustomTextField v-if="options && options.includes('branding')" :content=inputs.color />
    <div v-if="options && options.includes('branding')" class="file-filed-logo-container">
      <CustomFileField :content=inputs.logo />
      <div v-if="inputs.logo.value" class="logo-container">
        <img :src="logoUrl" alt="Logo du groupe" />
      </div>
      <div v-else class="logo-container">
        <span class="fa-solid fa-file-import"/>
      </div>
    </div>
    <CustomButton style="margin-top: 15px" @click="submitForm" :params=buttons.submit />
  </CustomForm>
</template>

<script>
    import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
    import router from "@/router";
    import {NotificationService} from "@vues/v-common";
    import {GroupController} from "@/controllers/user/GroupController";
    import CustomForm from "@/components/forms/CustomForm.vue";
    import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
    import {TokenService} from "@/services/TokenService";
    import CustomFileField from "@/components/forms/customs/customFileField/CustomFileField.vue";

    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faFileImport } from "@fortawesome/free-solid-svg-icons";
    library.add(faFileImport);

    export default {
        name: 'GroupParametersForm',
        components: {
          CustomFileField,
          CustomButton,
          CustomForm,
          CustomTextField,
        },
        computed: {
          logoUrl() {
            const logo = this.inputs.logo.value;

            if (!logo) return null;

            // Cas 1 — déjà encodé en base64
            if (typeof logo === 'object' && logo.data && logo.contentType) {
              return `data:${logo.contentType};base64,${logo.data}`;
            }

            // Cas 2 — fichier brut (type File)
            if (logo instanceof File) {
              return URL.createObjectURL(logo);
            }

            return null;
          }
        },
        data: function () {
            return {
                options: [],
                inputs: {
                  name: {label: 'Nom', value: '', readOnly: false, type: 'text'},
                  color: {label: 'Couleur', value: '', readOnly: false, type: 'text'},
                  logo: {label: 'Logo', value: '', textUpload: 'Changer de logo', textNotUpload: 'Téléverser un logo', readOnly: false},
                },
                buttons:{
                  submit: {text: "Mettre à jour"},
                },
                error: false,
                message: ""
            }
        },
        async mounted(){
            this.$refs.form?.startLoading();
            const resp = await GroupController.get(localStorage.groupId)
            if(!resp.errors){
              this.inputs.name.value = resp.name;
              this.inputs.color.value = resp.color;
              this.inputs.logo.value = resp.logo;
              this.options = resp.options;
            }
            this.$refs.form?.stopLoading();
        },
      methods: {
        async submitForm() {
          let data = new FormData();
          data.append('logo', this.inputs.logo.value);
          data.append('color', this.inputs.color.value);
          data.append('name', this.inputs.name.value);
          const res = await this.$refs.form.submitForm(() => GroupController.patch(localStorage.groupId, data));
          if (!res.errors) {
            (new NotificationService).addNotification("success","Groupe modifié");
            TokenService.renewToken();
            router.push("/group-parameters");
          }
        }
      }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';

  .file-filed-logo-container
    display flex
    height 80px
    gap 15px
    .logo-container
      padding-top 19px
      padding-right 13px
      display flex
      align-items center
      justify-content center
      width 90px
      height 55px
      aspect-ratio auto
      img
        max-width 100%
        max-height 100%
      .fa-file-import
        width 30px
        height 30px

  .tva-container
    display flex
    .numeroTVA
      margin-right 1em
    .TVA
      width 5em

  .separator
    margin-top 15px
    height 2px
    background-color THEME_COLOR_PRIMARY_FADDED
    opacity 0.6
</style>
